import { render, staticRenderFns } from "./myfooter.vue?vue&type=template&id=137cbd20&scoped=true"
import script from "./myfooter.vue?vue&type=script&lang=js"
export * from "./myfooter.vue?vue&type=script&lang=js"
import style0 from "./myfooter.vue?vue&type=style&index=0&id=137cbd20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qpbnisuf3xa42n7xmxbguasfv4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137cbd20",
  null
  
)

export default component.exports